import React, { useState, useEffect } from 'react';
import topics from '../../tickertopics.json';
import { useTranslation } from 'react-i18next';
import './componentDarkSurfaceFixes.css';

const Ticker = () => {
  const { t } = useTranslation('main');
  const [isPaused, setIsPaused] = useState(false);
  const [randomTopics, setRandomTopics] = useState<string[]>([]);

  useEffect(() => {
    // Try localized topics from i18n first
    const localized = t('main.ticker_topics', { returnObjects: true }) as unknown;
    const sourceArray = Array.isArray(localized) && localized.length > 0 ? (localized as string[]) : topics as string[];
    const shuffled = [...sourceArray].sort(() => 0.5 - Math.random());
    setRandomTopics(shuffled.slice(0, 25));
  }, [t]);

  const DotIcon = () => (
    <span className="sl-home-ticker-dot h-1 w-1 rounded-full bg-gray-400" aria-hidden="true" />
  );

  return (
    <div className="sl-home-ticker w-full overflow-x-clip border-y border-gray-100 bg-gradient-to-r from-gray-50 via-blue-50 to-gray-50 py-3.5">
      <div
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className="flex [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
          <div
            className="flex flex-none gap-12 pr-12 animate-move-left"
            style={{
              animationPlayState: isPaused ? 'paused' : 'running'
            }}
          >
            {[...new Array(3)].fill(0).map((_, index) => (
              <React.Fragment key={index}>
                {randomTopics.map((item, itemIndex) => (
                  <div key={`${index}-${itemIndex}`} className="inline-flex items-center gap-12">
                    <span className="sl-home-ticker-label whitespace-nowrap text-xs font-medium uppercase tracking-[0.08em] text-gray-500">
                      {item}
                    </span>
                    <DotIcon />
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ticker;
